module.exports = __webpack_public_path__ + "static/media/doc-delivery.cd714aee.svg";